import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import { formatEgresoNumero } from '../../../utils/formatEgresoNumero';

function ParametrosEgreso() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [consecutivo, setConsecutivo] = useState(null);
    const [prefijo, setPrefijo] = useState('');
    const [numeroConsecutivo, setNumeroConsecutivo] = useState('1');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const fetchParams = async () => {
            const config = {
                headers: { Authorization: 'Bearer ' + userdata.access_token }
            };

            try {
                const clientRes = await axios.get('/get-client?uid=' + userdata.user_id, config);
                if (clientRes.status === 200) {
                    setClient(clientRes.data);
                    setLoggedIn(true);
                }

                try {
                    const egresoRes = await axios.get('/consecutivo-egreso?uid=' + userdata.user_id, config);
                    if (egresoRes.status === 200 && egresoRes.data) {
                        setConsecutivo(egresoRes.data);
                        setPrefijo(egresoRes.data.prefijo_egreso || '');
                        setNumeroConsecutivo(egresoRes.data.consecutivo_egresos || '1');
                    }
                } catch (e) {
                    console.log('Sin consecutivo egreso');
                }
            } catch (error) {
                console.log('Error general:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchParams();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const userdata = JSON.parse(localStorage.getItem('userdata'));
        const data = {
            prefijo_egreso: prefijo || null,
            consecutivo_egresos: numeroConsecutivo,
        };

        try {
            let response;
            if (consecutivo) {
                response = await axios.put('/consecutivo-egreso?uid=' + userdata.user_id, data);
            } else {
                response = await axios.post('/consecutivo-egreso?uid=' + userdata.user_id, data);
            }

            if (response.status === 200 || response.status === 201) {
                alert('Consecutivo de egreso guardado exitosamente');
                setConsecutivo(response.data);
            }
        } catch (error) {
            alert('Error al guardar: ' + (error.response?.data?.message || error.message));
        }
    };

    if (!loggedIn || loading) {
        return <Loading />;
    }

    return (
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="settings" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                    <li className="breadcrumb-item"><Link to="/administrar-tratamientos">Administrador Contable</Link></li>
                                    <li className="breadcrumb-item active">Parámetros Egreso</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Parámetros Egreso</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="card card-secondary card-outline">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            <i className="fas fa-money-bill-wave"></i> Consecutivo Egreso
                                        </h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <label>Prefijo (Opcional)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={prefijo}
                                                    onChange={(e) => setPrefijo(e.target.value)}
                                                    placeholder="Ej: EG"
                                                    maxLength="10"
                                                />
                                                <small className="text-muted">
                                                    Puede coexistir egreso 0001 sin prefijo y EG-0001 con prefijo EG.
                                                </small>
                                            </div>
                                            <div className="form-group">
                                                <label>Consecutivo actual *</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={numeroConsecutivo}
                                                    onChange={(e) => setNumeroConsecutivo(e.target.value)}
                                                    min="1"
                                                    required
                                                />
                                            </div>

                                            <div className="alert alert-light border">
                                                <strong>Vista previa:</strong>{' '}
                                                {formatEgresoNumero(prefijo, numeroConsecutivo)}
                                            </div>

                                            <button type="submit" className="btn btn-secondary btn-block">
                                                <i className="fas fa-save"></i> Guardar consecutivo
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default ParametrosEgreso;
